import styled from "styled-components";

export const PaymentStatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PastDueText = styled.span`
  color: ${({ theme }) => theme.redDark};
  font-weight: bold;
`;

export const PastDueDate = styled.span`
  color: ${({ theme }) => theme.redDark};
`;
